'use strict';

var defaults = require('../../defaults/Defaults');
require('./DeviceService');
require('./RoomService');
var log = require('../../log/Log').channel('FactoryInstallController');
var QRCode = require('qrcode-svg');
var sutl = require('../../sutl/Sutl');

angular.module('inara').controller('FactoryInstallController', FactoryInstallController);

FactoryInstallController.$inject = ['$interval', '$scope', '$sce', '$q', 'RoomService', 'DeviceService' ];

function FactoryInstallController($interval, $scope, $sce, $q, RoomService, DeviceService) {
    var vm = this;
    var checklistInterval = null;

    log.info('initializing');
    vm.inaraName = defaults.inara.name;
    vm.controller = null;
    vm.factoryInstallChecklist = [];
    vm.qrCodeData = null;
    vm.qrCodeSvgString = null;

    $scope.$on('$stateChangeSuccess', onStateChanged);

    var extraFactoryInstallItems = [
        {
            name: 'Inara is unlicensed',
            getState: function() {
                if (vm.controller === null) return $q.resolve('unknown');
                return $q.resolve(vm.controller.license ? 'no' : 'yes');
            }
        },
    ];

    DeviceService.getFactoryInstallChecklist()
    .concat(extraFactoryInstallItems)
    .forEach(function(item) {
        vm.factoryInstallChecklist.push({
            name: item.name,
            state: 'unknown',
        });
    });

    function onStateChanged(event, toState, toParams, fromState, fromParams) {
        if (fromState.name !== 'factoryInstall' && toState.name === 'factoryInstall') {
            vm.controller = null;

            if (checklistInterval !== null) {
                log.error('checklistInterval not null');
                $interval.cancel(checklistInterval);
            }

            updateFactoryInstallChecklist();
            checklistInterval = $interval(updateFactoryInstallChecklist, 2000);

            $q.resolve()
            .then(function() {
                if (DeviceService.getCaps().hasAllowOtaUpgrade) {
                    return DeviceService.setAllowOtaUpgrade(true);
                }
            });
            RoomService.onStateChanged(onRoomServiceStateChanged);
        } else if (fromState.name === 'factoryInstall' && toState.name !== 'factoryInstall') {
            RoomService.offStateChanged(onRoomServiceStateChanged);

            if (checklistInterval !== null) {
                $interval.cancel(checklistInterval);
                checklistInterval = null;
            }

            $q.resolve()
            .then(function() {
                if (RoomService.isControllerLoaded() &&
                    DeviceService.getCaps().hasAllowOtaUpgrade) {
                    return DeviceService.setAllowOtaUpgrade(
                        RoomService.getController().settings.otaUpgradeEnabled);
                }

                return $q.resolve();
            });

            vm.controller = null;
        }
    }

    function onRoomServiceStateChanged(state) {
        if (vm.controller === null && RoomService.isControllerLoaded()) {
            vm.controller = RoomService.getController();
        }
        log.debug('onRoomServiceStateChanged: state = ' + state + ', controller = ' + vm.controller);
    }

    function updateFactoryInstallChecklist() {
        DeviceService.getFactoryInstallChecklist()
        .concat(extraFactoryInstallItems)
        .forEach(function(item) {
            item.getState()
            .then(function(state) {
                vm.factoryInstallChecklist.forEach(function(ci) {
                    if (ci.name === item.name) {
                        ci.state = state;
                    }
                });
            });
        });
    }

    vm.exit = function() {
        var controller = RoomService.getController();
        controller.settings.factoryInstallMode = false;
        controller.$save(false);
    };

    vm.getQrCode = function() {
        var qrCodeData = '';

        qrCodeData += vm.controller !== null &&
            vm.controller.hasOwnProperty('model') ?
            vm.controller.model : 'MISSING';
        qrCodeData += '$';
        qrCodeData += vm.controller !== null &&
            vm.controller.hasOwnProperty('serialNumber') ?
            vm.controller.serialNumber : 'MISSING';
        qrCodeData += '$';
        qrCodeData += vm.controller !== null &&
            vm.controller.hasOwnProperty('networkInterfaces') &&
            vm.controller.networkInterfaces.hasOwnProperty('eth0') &&
            vm.controller.networkInterfaces.eth0.hasOwnProperty('hardwareAddress') ?
            vm.controller.networkInterfaces.eth0.hardwareAddress.replace(/:/g, '') : 'MISSING';
        qrCodeData += '$';
        qrCodeData += vm.controller !== null &&
            vm.controller.hasOwnProperty('networkInterfaces') &&
            vm.controller.networkInterfaces.hasOwnProperty('wlan0') &&
            vm.controller.networkInterfaces.wlan0.hasOwnProperty('hardwareAddress') ?
            vm.controller.networkInterfaces.wlan0.hardwareAddress.replace(/:/g, '') : 'MISSING';
        qrCodeData = qrCodeData.toUpperCase();

        if (vm.qrCodeSvgString === null || vm.qrCodeData !== qrCodeData) {
            log.debug('getQrCode: qrCodeData = ' + qrCodeData);
            vm.qrCodeData = qrCodeData;
            vm.qrCodeSvgString = new QRCode({
                content: qrCodeData,
                width: 120,
                height: 120,
                padding: 0,
                background: 'none',
                join: true,
                swap: true // required for Zebra scanner compatibility
            }).svg();
        }

        return $sce.trustAsHtml(vm.qrCodeSvgString);
    };

    vm.getKioskModeEnabled = function() {
        return sutl.getNode(vm.controller, 'settings.kioskModeEnabled',
            defaults.inara.kioskModeEnabled);
    };

    vm.toggleKioskModeEnabled = function() {
        sutl.setNode(vm.controller, 'settings.kioskModeEnabled',
            !vm.getKioskModeEnabled());
        vm.controller.$save();
    };
}

module.exports = FactoryInstallController;
